'use strict';

const { h, Component } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');

const EmailCTA = require('./email-cta');
const { isEmailValid } = require('../../support/email-helper');

function enterKeyPressed(event) {
  const enterKeyCode = 13;

  return event.code === 'Enter' || event.keyCode === enterKeyCode;
}

class EmailSubscriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      subscribed: false,
      errors: {
        subscription: false,
        email: false,
      },
      showLoading: false,
    };
  }

  keyUpHandler(event) {
    if (!enterKeyPressed(event)) {
      const { value: email } = event.target;
      const newState = { email };

      if (this.state.subscribed) {
        newState.subscribed = false;
      }

      if (this.state.errors.email) {
        newState.errors = {
          email: !isEmailValid(email),
        };
      }

      this.setState(newState);
    }
  }

  submit(event) {
    event.preventDefault();

    const { email } = this.state;

    const validEmail = isEmailValid(email);

    if (!validEmail) {
      const newSate = {
        subscribed: false,
        errors: {
          email: !validEmail,
        },
      };

      this.setState(newSate);
      return;
    }

    this.setState({ showLoading: true });

    const { csrfToken, routes } = this.props;
    const payload = {
      email,
    };

    fetch(routes.email_subscription.main, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'csrf-token': csrfToken,
      },
      body: JSON.stringify(payload),
    }).then(res => {
      const newState = res.ok
        ? {
            subscribed: true,
            errors: {
              subscription: false,
            },
            showLoading: false,
          }
        : {
            errors: {
              subscription: true,
            },
            showLoading: false,
          };

      this.setState(newState);
    });
  }

  render() {
    const { csrfToken, routes } = this.props;

    return h(
      'form.email-subscription-form',
      {
        onSubmit: event => this.submit(event),
        novalidate: 'novalidate',
        autocomplete: 'off',
      },
      h('input', { type: 'hidden', name: '_csrf', value: csrfToken }),
      this.state.errors.email
        ? h(
            Translate,
            {
              tag: 'div',
              attrs: { class: 'input-error' },
            },
            'js.modules.email_subscription.EmailInputError'
          )
        : null,
      h(WithI18n, {}, i18n =>
        h('input', {
          placeholder: i18n.t('js.modules.email_subscription.Email'),
          'aria-label': i18n.t('js.modules.email_subscription.Email'),
          type: 'email',
          'data-bhc': 'input:email',
          onKeyUp: event => this.keyUpHandler(event),
        })
      ),
      EmailCTA({
        showLoading: this.state.showLoading,
        subscribed: this.state.subscribed,
      }),
      h(
        Translate,
        {
          tag: 'div',
          attrs: {
            class: 'agreement',
          },
          0: h(
            Translate,
            {
              tag: 'a',
              attrs: { href: routes.terms },
            },
            'js.modules.footer.TermsLinkText'
          ),
          1: h(
            Translate,
            {
              tag: 'a',
              attrs: {
                href: routes.privacy,
              },
            },
            'js.modules.email_subscription.Privacy'
          ),
        },
        'js.modules.email_subscription.Agreement'
      ),
      this.state.errors.subscription &&
        h(
          Translate,
          {
            attrs: { class: 'email-subscription-error' },
          },
          'js.modules.email_subscription.Error'
        )
    );
  }
}

module.exports = EmailSubscriptionForm;
